'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_OS = exports.bpfrpt_proptype_BrowserName = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bpfrpt_proptype_BrowserName = _propTypes2.default.oneOf(['edge', 'yandexbrowser', 'vivaldi', 'kakaotalk', 'chrome', 'phantomjs', 'crios', 'firefox', 'fxios', 'opera', 'ie', 'ie', 'ie', 'bb10', 'android', 'ios', 'safari']);

var bpfrpt_proptype_OS = _propTypes2.default.oneOf(['iOS', 'Android OS', 'BlackBerry OS', 'Windows Mobile', 'Amazon OS', 'Windows 3.11', 'Windows 95', 'Windows 98', 'Windows 2000', 'Windows XP', 'Windows Server 2003', 'Windows Vista', 'Windows 7', 'Windows 8', 'Windows 8.1', 'Windows 10', 'Windows ME', 'Open BSD', 'Sun OS', 'Linux', 'Mac OS', 'QNX', 'BeOS', 'OS/2', 'Search Bot']);

exports.bpfrpt_proptype_BrowserName = bpfrpt_proptype_BrowserName;
exports.bpfrpt_proptype_OS = bpfrpt_proptype_OS;